import { Loader } from '@/ui/Loader'
import { useGetVehicleAllocation } from '../../api/useGetVehicleAllocation'
import { VehicleAllocationColumn } from './VehicleAllocationColumn'
import styles from './VehicleAllocationList.module.scss'
import { useWorkstationStore } from '@/modules/Workstation/store'
import { sortAlphanumeric } from '../../helpers/sortAlphanumeric'

export const VehicleAllocationList = () => {
    const { data, isFetching } = useGetVehicleAllocation()
    const { routes: workstationRoutes } = useWorkstationStore()

    const workstationRouteSet = new Set(workstationRoutes.map((route) => route.route))

    const sortedVehicleAllocations = [...(data?.vehicleAssignments || [])].sort((a, b) => {
        const aIsWorkstationRoute = workstationRouteSet.has(a.route)
        const bIsWorkstationRoute = workstationRouteSet.has(b.route)

        if (aIsWorkstationRoute && !bIsWorkstationRoute) {
            return -1
        }
        if (!aIsWorkstationRoute && bIsWorkstationRoute) {
            return 1
        }

        return sortAlphanumeric(a, b)
    })

    if (isFetching) {
        return <Loader />
    }

    return (
        <div className={styles.scrollContainer}>
            {sortedVehicleAllocations.map((allocation) => (
                <VehicleAllocationColumn key={allocation.route} allocation={allocation} />
            ))}
        </div>
    )
}
